// extracted by mini-css-extract-plugin
export var content = "QuickActions-module--content--biRKQ";
export var intro = "QuickActions-module--intro--l5gsQ";
export var transitionContainer = "QuickActions-module--transitionContainer--DWlS1";